import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const AGBPage = () => {
  return (
    <div className="min-h-screen bg-[#1A1D23]">
      <header className="h-16 flex items-center px-6 border-b border-white/5">
        <Link to="/" className="flex items-center gap-2" data-testid="agb-logo">
          <div className="w-8 h-8 bg-[#EC2229] rounded-lg flex items-center justify-center">
            <span className="font-heading font-bold text-white text-sm">TX</span>
          </div>
          <span className="font-heading font-bold text-white text-lg">TrXL Performance</span>
        </Link>
      </header>

      <main className="max-w-3xl mx-auto px-6 py-12" data-testid="agb-content">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-slate-400 hover:text-white mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4" />
          Zurück zur Startseite
        </Link>

        <h1 className="font-heading text-3xl font-bold text-white mb-8">Allgemeine Geschäftsbedingungen (AGB)</h1>

        <div className="prose prose-invert max-w-none space-y-6 text-slate-300 text-sm leading-relaxed">
          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 1 Geltungsbereich</h2>
            <p>
              (1) Diese Allgemeinen Geschäftsbedingungen (AGB) gelten für alle Geschäftsbeziehungen zwischen
              TrXL Performance, Sven Trachsel, Schilfweg 5, 28857 Syke (nachfolgend „Anbieter") und dem Kunden
              (nachfolgend „Auftraggeber").
            </p>
            <p>
              (2) Es gelten ausschließlich diese AGB. Abweichende Bedingungen des Auftraggebers werden nicht
              anerkannt, es sei denn, der Anbieter stimmt ihrer Geltung ausdrücklich schriftlich zu.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 2 Leistungsbeschreibung</h2>
            <p>
              (1) Der Anbieter bietet einen ECU-Fileservice an. Der Auftraggeber übermittelt über das Portal
              Steuergeräte-Dateien zur Optimierung. Der Anbieter bearbeitet diese Dateien nach den vom
              Auftraggeber gewählten Optionen.
            </p>
            <p>
              (2) Die bearbeiteten Dateien werden über das Portal zum Download bereitgestellt.
            </p>
            <p>
              (3) Der Anbieter übernimmt keine Garantie für die Kompatibilität der bearbeiteten Dateien mit
              dem Fahrzeug des Endkunden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 3 Registrierung und Nutzerkonto</h2>
            <p>
              (1) Die Nutzung des Fileservice-Portals erfordert eine Registrierung. Der Auftraggeber ist
              verpflichtet, wahrheitsgemäße und vollständige Angaben zu machen.
            </p>
            <p>
              (2) Der Auftraggeber ist für die Geheimhaltung seiner Zugangsdaten verantwortlich und haftet
              für alle Aktivitäten, die unter seinem Konto erfolgen.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 4 Preise und Zahlungsbedingungen</h2>
            <p>
              (1) Die Abrechnung erfolgt über ein Credit-System. 1 Credit entspricht 15,00 EUR netto.
              Credits können über Stripe (Kreditkarte) oder PayPal erworben werden.
            </p>
            <p>
              (2) Alle angegebenen Preise verstehen sich zuzüglich der gesetzlichen Mehrwertsteuer.
            </p>
            <p>
              (3) Erworbene Credits sind nicht erstattungsfähig und können nur für Leistungen innerhalb
              des Portals verwendet werden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 5 Bearbeitungszeiten</h2>
            <p>
              (1) Die angegebenen Bearbeitungszeiten sind unverbindlich. Der Anbieter bemüht sich, Dateien
              schnellstmöglich zu bearbeiten.
            </p>
            <p>
              (2) Bei Service-Ausfällen oder Wartungsarbeiten kann es zu Verzögerungen kommen. Der
              Auftraggeber wird über den Servicestatus im Portal informiert.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 6 Revisionen</h2>
            <p>
              (1) Sollte eine bearbeitete Datei nicht den gewünschten Spezifikationen entsprechen, kann der
              Auftraggeber eine kostenlose Revision anfordern.
            </p>
            <p>
              (2) Die Revision muss innerhalb von 14 Tagen nach Bereitstellung der Datei angefordert werden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 7 Haftung</h2>
            <p>
              (1) Der Anbieter haftet nicht für Schäden am Fahrzeug, die durch die Verwendung der bearbeiteten
              Dateien entstehen. Die Verantwortung für den Einbau und die Verwendung liegt beim Auftraggeber
              bzw. dessen Endkunden.
            </p>
            <p>
              (2) Der Auftraggeber bestätigt, dass die bearbeiteten Dateien ausschließlich im Rahmen der
              geltenden Gesetze und Vorschriften verwendet werden.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 8 Datenschutz</h2>
            <p>
              Die Erhebung und Verarbeitung personenbezogener Daten erfolgt gemäß unserer
              Datenschutzerklärung und den geltenden Datenschutzgesetzen (DSGVO).
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 9 Shop / Hardware-Verkauf</h2>
            <p>
              (1) Für den Verkauf von Hardware-Produkten (z.B. Tuning-Tools) gelten ergänzend die
              gesetzlichen Bestimmungen für den Fernabsatz.
            </p>
            <p>
              (2) Die Zahlung erfolgt per Vorkasse (Banküberweisung) oder PayPal. Der Versand erfolgt
              nach Zahlungseingang.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-3">§ 10 Schlussbestimmungen</h2>
            <p>
              (1) Es gilt das Recht der Bundesrepublik Deutschland.
            </p>
            <p>
              (2) Gerichtsstand für alle Streitigkeiten ist Syke, sofern der Auftraggeber Kaufmann ist.
            </p>
            <p>
              (3) Sollten einzelne Bestimmungen dieser AGB unwirksam sein, bleibt die Wirksamkeit der
              übrigen Bestimmungen unberührt.
            </p>
          </section>

          <p className="text-slate-500 mt-8">Stand: Februar 2026</p>
        </div>
      </main>

      <footer className="py-6 px-6 border-t border-white/5">
        <div className="max-w-3xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-4 text-sm text-slate-500">
          <p>© {new Date().getFullYear()} TrXL Performance. Alle Rechte vorbehalten.</p>
          <div className="flex gap-6">
            <Link to="/impressum" className="hover:text-white transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-white transition-colors">Datenschutz</Link>
            <Link to="/agb" className="text-white">AGB</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default AGBPage;
